import { takeCustomLatest } from 'state/common/common.effects'
import { NEW_DASHBOARD_EVENTS_ACTIONS } from './events.actions'
import { newDashBoardEventsEffect } from './events.analytics'

function* pushEventSaga() {
  yield takeCustomLatest(NEW_DASHBOARD_EVENTS_ACTIONS.SEND, newDashBoardEventsEffect)
}

export const EventsWatchers = [pushEventSaga()]
